import * as companyActionTypes  from '../_actionTypes/company';

export const companyReducer = (state = { }, action) => {
    switch(action.type){
      case companyActionTypes.GET:
        return state = action.company
      default:
        return state
    }
}